import { Can } from '../../../../context/Ability';
import { TabPanel } from '@mui/lab';
import { Grid, useMediaQuery } from '@mui/material';
import GiftTable from './GiftTable';
import GiftPreview from '../common/GiftPreview';
import EditPreview from '../common/EditPreview';
import { useSelector } from 'react-redux';
import { selectJuniorPreviousForms, selectShowSubmittedHistory } from '../../giftSlice';
import SwipeEdge from '../../../../common/SwipeEdge';
import PreviousGift from '../common/PreviousGift';

const SubmittedGift = () => {
  const showHistory = useSelector(selectShowSubmittedHistory);
  const forms = useSelector(selectJuniorPreviousForms);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

  return (
    <Can I='read' a='GiftForm'>
      {/* Only visible if the user has permission to read forms submitted to him */}
      <TabPanel value='submitted' sx={{ width: 1, p: 0, height: `calc(100vh - ${isMobile ? '0px' : '130px'})` }}>
        <Grid container sx={{ height: '100%'}}>
          {showHistory ? <PreviousGift forms={forms} showEmployee={true} /> : <GiftTable />}
          {!isMobile && <GiftPreview />}
          <EditPreview />
        </Grid>
      </TabPanel>
      <SwipeEdge title={'GIFT preview'} content={<GiftPreview />} drawerBleeding={0} />
    </Can>
  );
};

export default SubmittedGift;
